import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SearchUI from '../../../widgets/input/SearchUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import TxnDownloadModalSF from './TxnDownloadModalSF'
// import './TransactionList.css'

const ZTransactionListUI = ({ context, txnList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  hasMore, onMoreTransactions, gettingMore,
  downloadMode, onDownloadClick, onDownloadCancel, bankAccountNumber
}) =>
  <div className='txns g_m_top_100'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          onDownloadClick={onDownloadClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        txnList.map((txn, i) =>
          <TxnRowUI key={i} context={context} txn={txn} />
        )
      }
    </LRTableBodyUI>

    <LRTableActionsUI location='bottom'
      left={<span />}
      right={
        <div>
          {
            hasMore &&
            <div className='action g_flex_h'>
              <SpinnerUI show={gettingMore} />
              <span className='g_m_left_50' />
              <ButtonUI label='More' onClick={onMoreTransactions} />
            </div>
          }
          {
            !hasMore &&
            <div>All transactions displayed</div>
          }
        </div>
      }
    />

    <TxnDownloadModalSF context={context} downloadMode={downloadMode}
      onCancelClick={onDownloadCancel}
      bankAccountNumber={bankAccountNumber}
    />
    {/*
    onUpdate={onUpdate} account={account}
    parameterName={parameterName} financialYear={financialYear} parameterValue={parameterValue}
    */}

  </div>

const TxnRowUI = ({ context, txn }) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} txn={txn} />}
    right={<RowRightUI context={context} txn={txn} />}
    className='g_flex_top'
  />

const RowLeftUI = ({ context, txn }) =>
  <div className='g_flex_v'>
    <span className='g_muted g_small'>
      {txn.transactionDateF}
    </span>
    <span>
    <span>{txn.payee}</span> <span className='g_muted'>{txn.description}</span>
    </span>
    {
      (txn.referenceId || txn.bankReferenceNum) &&
      <span className='g_muted'>
        Ref: {txn.referenceId} {txn.bankReferenceNum}
      </span>
    }
  </div>

const RowRightUI = ({ context, txn }) =>
  <div className='g_flex_v g_text_right'>
    {
      txn.status &&
      <div>
        <BadgeUI label={txn.status} />
      </div>
    }
    <span className='g_flex_h g_flex_right'>
      <span>{txn.amount < 0 ? `(${txn.amountF2})` : `${txn.amountF2}`}</span>
      {/* runningAmount is not correct in the API
      <span className='g_muted g_m_left_50'>{txn.runningAmountF2}</span>
      */}
    </span>
    {
      txn.tdsAmountF2 &&
      <span className='g_muted'>TDS {txn.tdsSection} @{txn.tdsRate}% {txn.tdsAmountF2}</span>
    }
    {/*
      bill.taxList.map((tax, j) =>
        <tr key={j}>
          <td className='g_no_wrap_2'>{tax.name}</td>
          <td className='g_text_right'>{tax.amountF2}</td>
        </tr>
      )
    */}
  </div>

const ActionLeftUI = ({ context, onRefreshClick, onDownloadClick}) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
    <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
  </div>

const ActionTopRightUI = ({ context, searchFilter, onSearchFilterChange
}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default ZTransactionListUI
